<template>
  <div
    class="tabbed"
  >
    <ul class="tabbed__tabs">
      <li class="tabbed__tab">
        <a class="tab__name">
          {{ title }}
        </a>
      </li>
    </ul>

    <div class="tabbed__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabbed',
  props: {
    title: { type: String, required: true }
  }
};
</script>
